import React, { lazy } from 'react'
import LandingPage from '../components/pages/LandingPage'
import LoginNew from '../components/auth/LoginNew'
import SignUp from '../components/auth/Signup'
import Register from '../components/auth/SignupNew'
import ForgotPasswordNew from '../components/auth/ForgotPasswordNew'
import ResetPasswordNew from '../components/auth/ResetPasswordNew'
import ViewRequest from '../components/pages/ViewRequest'
import AccountDetails from '../components/dashboard/AcountDetails'

const Users = lazy(() => import('../components/users/Users'))
const Dashboard = lazy(() => import('../components/dashboard/Dashboard'))

export const ROUTES_WITHOUT_SIDEBAR = [
  {
    path: '/login',
    element: (props) => <LoginNew authActions={props.actions.authActions} authState={props.authState} />
  },
  {
    path: '/signup',
    element: (props) => <SignUp authActions={props.actions.authActions} authState={props.authState} />
  },
  {
    path: '/register',
    element: () => <Register />
  },
  {
    path: '/forgot-password',
    element: (props) => <ForgotPasswordNew authActions={props.actions.authActions} authState={props.authState} />
  },
  {
    path: '/reset-password',
    element: (props) => <ResetPasswordNew authActions={props.actions.authActions} authState={props.authState} />
  },
  {
    path: '/account',
    element: (props) => (
      <AccountDetails
        authActions={props.actions.authActions}
        authState={props.authState}
        dashboardActions={props.actions.dashboardActions}
        dashboardState={props.dashboardState}
      />
    )
  },
  {
    path: '/',
    element: () => <LandingPage />
  },
  {
    path: '/view-request',
    element: () => <ViewRequest />
  },
  {
    path: '/workshop-account',
    element: () => <ViewRequest isWorkshopAccountCreation />
  },
  {
    path: '*',
    element: () => <LandingPage />
  }
]

export const ROUTES_WITH_SIDEBAR = [
  {
    path: '/dashboard',
    protected: true,
    element: (props) => <Dashboard
      authActions={props.actions.authActions}
      authState={props.authState}
      dashboardActions={props.actions.dashboardActions}
      dashboardState={props.dashboardState}
                        />
  },
  {
    path: '/users',
    protected: true,
    sysAdminCheck: true,
    element: (props) => <Users {...props} />
  }
]
